import { Snackbar, Typography } from '@mui/material'
import { getUser } from '../util/LoginUser'
import PasswordChangeForm from '../component/form/PasswordChangeForm'
import { useEffect, useState } from 'react'
import { passwordChange } from '../util/user/PsswordChange'

const UserSettingPage = (props) =>{

  // const user = getUser();

  const [passwordInfo,setPasswordInfo] = useState({
    currentpassword: '',
    newpassword: '',
    confirmpassword: ''
  })

  const [snackBar,setSnackBar] = useState(false);


  useEffect(() => {

    if(passwordInfo.newpassword){
      passwordChange(passwordInfo);
      setSnackBar(true)
      clear();
    }
  },[passwordInfo])


  const changePassword = (row) => {
    setPasswordInfo(row);
  }

  const clear = () =>{
    setPasswordInfo(
      {
        currentpassword: '',
        newpassword: '',
        confirmpassword: ''
      }
    )
  };

  return (
    <>
      <Typography variant={"h4"} >設定</Typography>

      <PasswordChangeForm  process={changePassword} current={true}/>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        open={snackBar}
        onClose={()=>{setSnackBar(false)}}
        message="パスワード変更が反映されました"
        key='passwordchange'
      />
    </>
  );
}

export default UserSettingPage